import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { IconButton } from '@mui/material';

export interface CarouselArrowProps {
  isDisabled?: boolean;
}

export function CarouselArrow({
  direction,
  isDisabled,
}: CarouselArrowProps & {
  direction: 'previous' | 'next';
}) {
  const isPrevious = direction === 'previous';
  const Icon = isPrevious ? ArrowBackIosNewIcon : ArrowForwardIosIcon;

  return (
    <IconButton
      aria-label={isPrevious ? 'Item anterior' : 'Próximo item'}
      disabled={isDisabled}
      sx={{
        color: 'text.primary',
        bgcolor: 'transparent',
        width: 24,
        height: 24,
        boxShadow: 'none',
        '&:hover': { bgcolor: 'transparent', color: 'primary.main' },
        '&.Mui-disabled': {
          bgcolor: 'transparent',
          color: 'action.disabled',
        },
      }}>
      <Icon sx={{ fontSize: 18 }} />
    </IconButton>
  );
}
